import React from 'react';
import { useLocale } from '../i18n/LocaleContext';

// Shown while a route's code chunk downloads. It announces itself politely so
// screen-reader users hear that something is loading instead of silence.
const RouteFallback = () => {
  const { t } = useLocale();

  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-[100dvh] flex items-center justify-center bg-[#f2f3d9]"
    >
      <span className="font-space text-[#262624]/60 text-sm uppercase tracking-[0.22em]">
        {t('common.loading')}
      </span>
    </div>
  );
};

export default RouteFallback;
